class QuickViewUpsell {
  constructor(selector) {
    this.selector = selector;
    this.observer = null;
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => this.observeQuickView());
  }

  observeQuickView() {
    const target = document.querySelector(this.selector);
    if (!target) return;

    this.observer = new MutationObserver(() => this.addUpsellInput());
    this.observer.observe(target, { childList: true, subtree: true });
  }

  addUpsellInput() {
    const quickViewContainer = document.querySelector(this.selector);
    const form = quickViewContainer?.querySelector('form');
    if (!form) return;

    if (!form.querySelector('input[name="properties[_Upsell]"]')) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[_Upsell]';
      hiddenInput.value = 'Cart Upsell';
      form.appendChild(hiddenInput);
    }
  }
}

new QuickViewUpsell('[data-quick-view-container]');